import React from 'react'
import { IQueryBuilderComponent } from '../IQueryBuilderComponent'
import SliderComponent from '../Slider.component'
import { toIsoDateString } from '../../lib/utils'
import { createParameter } from '../../lib/api'

class FilterByHoursCriteria extends IQueryBuilderComponent<
  {},
  { value: number }
> {
  state = { value: 1 }

  getStartDate = () => {
    const now = new Date().getTime()
    const diff = 1000 * 60 * 60 * this.state.value
    return new Date(now - diff)
  }

  getParameters() {
    const now = new Date().getTime()
    const diff = 1000 * 60 * 60 * this.state.value
    return [createParameter('start', toIsoDateString(new Date(now - diff)))]
  }

  getType() {
    return 'date'
  }

  handleOnChange = (value: number) => this.setState({ value })

  render() {
    return (
      <>
        <div className="four wide column">
          <h4>
            Within {this.state.value} hour{this.state.value === 1 ? '' : 's'}
          </h4>
        </div>
        <div className="four wide column">
          <SliderComponent
            min={1}
            max={24}
            onChange={this.handleOnChange}
            value={this.state.value}
          />
        </div>
        <div className="four wide column">
          from {this.getStartDate().toLocaleString()}
        </div>
      </>
    )
  }
}

export default FilterByHoursCriteria
